import styled from 'styled-components';

export const ContainerStatus = styled.div`
  padding-top: 10px;
`;

export const ContainerAvatar = styled.div`
  padding-right: 2px;
  padding-left: 6px;
`;

export const RowAvatar = styled.div`
  display: flex;
`;

export const Footer = styled.div`
  margin: 34px 0px;
`;
